import React from 'react'
import './Button.css'

const Button = props => {
  return (
    <a
      className="fmbm-button"
      href={props.href}
      style={props.style}
      target={props.href && props.href.includes('http') ? '_blank' : ''}
    >
      {props.buttonText}
    </a>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/Components/Button/Button.js